import type { Result } from '../core/result';
import type { Layout } from './types';
import type { WaterClassesFile } from './generated/waterClasses';
import { parseWaterClasses } from './waterClasses';
import committed from './waterClasses.json';

// tools/fields derives the classes offline from the painting; the build bundles them, so the app
// never decodes the image.
export function loadWaterClasses(layout: Layout): Result<WaterClassesFile, readonly string[]> {
  return parseWaterClasses(committed, layout);
}
